module.exports = __webpack_public_path__ + "static/media/debut.ea3b3a15.jpg";